import React, { createContext, useContext, useRef, useEffect } from "react";
import { createChatSocket } from "../utils/chatSocket";

const ChatSocketContext = createContext(null);

export function ChatSocketProvider({ children }) {
  const socketRef = useRef(null);

  if (!socketRef.current) {
    socketRef.current = createChatSocket();
  }

  useEffect(() => {
    const s = socketRef.current;
    return () => {
      if (s) {
        s.offAny();
        s.disconnect();
      }
    };
  }, []);

  return (
    <ChatSocketContext.Provider value={socketRef.current}>
      {children}
    </ChatSocketContext.Provider>
  );
}

export function useChatSocket() {
  return useContext(ChatSocketContext);
}

export default ChatSocketContext;
